<template>
  <div class="relative flex justify-center items-center w-full h-full">
    <img :class="raiseSide" id="doll" class="z-10" />
    <div
      :class="raiseSide"
      id="load"
      class="absolute flex justify-center items-center w-full h-full z-0"
    >
      <img />
      <img />
    </div>
    <div
      :class="raiseSide"
      id="text"
      class="absolute flex justify-center items-center w-full h-full z-0"
    >
      <span class="text black">Back</span>
      <span class="text blue">Next</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HandRaise',
  props: {
    raiseSide: {
      type: String,
      default: 'none',
    },
  },
};
</script>

<style lang="scss" scoped>
$load-width: 17.4%;
$load-distance: 9%;
#doll {
  width: 38%;
  content: url(../../assets/Tutorial/fistBody.svg);
}
#doll.right,
#doll.left {
  content: url(../../assets/Tutorial/fistBodyRaise.svg);
}
#doll.left {
  transform: scaleX(-1);
}
.none {
  img:nth-child(1) {
    width: $load-width;
    margin-right: $load-distance;
    content: url(../../assets/Tutorial/loading/blackLoad.svg);
  }
  img:nth-child(2) {
    width: $load-width;
    margin-left: $load-distance;
    content: url(../../assets/Tutorial/loading/blueLoad.svg);
  }
}
.right {
  img:nth-child(1) {
    width: $load-width;
    margin-right: $load-distance;
    content: url(../../assets/Tutorial/loading/blackCircleLight.svg);
  }
  img:nth-child(2) {
    width: 13%;
    margin-left: $load-distance;
    content: url(../../assets/Tutorial/loading/blueSolid.svg);
  }
}
.left {
  img:nth-child(1) {
    width: 13%;
    margin-right: $load-distance;
    content: url(../../assets/Tutorial/loading/blackSolid.svg);
  }
  img:nth-child(2) {
    width: $load-width;
    margin-left: $load-distance;
    content: url(../../assets/Tutorial/loading/blackCircleLight.svg);
  }
}
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@700&display=swap');
.text {
  font-family: 'Open Sans';
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: normal;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  @screen lg {
    font-size: 32px;
  }
  @screen xs {
    font-size: 12px;
  }
}
.black {
  background-image: linear-gradient(to top, #131313, #656565);
  margin-right: 33%;
}
.blue {
  background-image: var(--brand-gradient-vertical);
  margin-left: 33%;
}
</style>
